'use client';

export function UpdateConsent() {
  const updateConsent = () => {
    if (typeof window !== 'undefined' && window?.JLG?.consent) {
      window.JLG.consent.updatePrivacyConsent();
    }
  };

  return (
    <button
      type="button"
      className="cursor-pointer text-xs bg-transparent border-0 p-0 hover:underline text-white font-medium inline"
      onClick={updateConsent}
      aria-label="Update Your Cookie Consent"
    >
      Update Your Cookie Consent
    </button>
  );
}

export default UpdateConsent;
